import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { UserDTO } from "../../harvest-engine/core/models/user";
import { TenantModuleDTO } from "../../harvest-engine/core/models/tenant-module";
import { PlatformModuleDTO } from "../../harvest-engine/core/models/platform-module";
import { CreateTenantRequest } from "../../harvest-engine/core/models/create-tenant-request";
import { CreateTenantResult } from "../../harvest-engine/core/models/create-tenant-result";
import { DevTenantCredentialsResult } from "../../harvest-engine/core/models/dev-tenant-credentials-result";


@Injectable({
  providedIn: 'root'
})
export class UsersService {
  protected basePath = '/';

  private token: string;

  constructor(
    protected httpClient: HttpClient,
  ) {
    this.token = 'Bearer '.concat(localStorage.getItem('access_token'));
    this.basePath = environment.PLATFORM_API_URL;
    
  }

  public apiUsersCreateUserPost(body?: UserDTO): Observable<UserDTO> {

    return this.httpClient.post(`${this.basePath}/api/Users/CreateUser`, body);
  }

  public apiUsersDeleteUserDelete(id?: number): Observable<any> {

    return this.httpClient.delete(`${this.basePath}/api/Users/DeleteUser/${id}`);
  }

  public apiUsersGet(): Observable<UserDTO[]> {
    return this.httpClient.get<UserDTO[]>(`${this.basePath}/api/Users`);
  }

  public apiUserGet(platformUserId: number): Observable<UserDTO> {

    return this.httpClient.get(`${this.basePath}/api/Users/${encodeURIComponent(String(platformUserId))}`);
  }

  public apiUserByPlatformId(platformUserId:number):Observable<UserDTO>{

    return this.httpClient.get(`${this.basePath}/api/Users/GetUserByPlatformId/${encodeURIComponent(String(platformUserId))}`);
  }


  public apiUsersGetCurrentUserGet(): Observable<UserDTO> {

    return this.httpClient.get(`${this.basePath}/api/Users/GetCurrentUser`);
  }

  public apiUsersUpdateUserPost(body?: UserDTO, updatePassword?: boolean,): Observable<UserDTO> {

    let queryParameters = new HttpParams();
    if (updatePassword !== undefined && updatePassword !== null) {
      queryParameters = queryParameters.set('updatePassword', <any>updatePassword);
    }

    return this.httpClient.put(`${this.basePath}/api/Users/UpdateUser`, body,
      {
        params: queryParameters
      }
    );
  }

  public apiAssignTenantModule(tenantModuleDTO: TenantModuleDTO[]){
    let queryParameters = new HttpParams();

    return this.httpClient.post(`${this.basePath}/api/Users/AssignTenantModule`,tenantModuleDTO,
      {
        params: queryParameters
      }
    )

  }


  public apiRolesByIdGet(id: number): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiRolesByIdGet.');
    }

    return this.httpClient.get(`${this.basePath}/api/Roles/${encodeURIComponent(String(id))}`);
  }

  public apiRolesGet(): Observable<any> {
    return this.httpClient.get(`${this.basePath}/api/Roles`);
  }

  public apiGetAllRoles(): Observable<any> {
    return this.httpClient.get(`${this.basePath}/api/Roles/GetAllRoles`);
  }


  public apiGroupRolesGet(): Observable<any> {
    return this.httpClient.get(`${this.basePath}/api/GroupRoles`);
  }

    public apiGroupRolesPut(roleGroup: any): Observable<any> {

    return this.httpClient.put<any>(
      `${this.basePath}/api/GroupRoles`,
      roleGroup
    );
  }

  // POST (add new group role)
  public apiGroupRolesPost(roleGroup: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.basePath}/api/GroupRoles`,
      roleGroup
    );
  }

  public apiGroupRolesDelete(roleGroupId: number): Observable<any> {

  return this.httpClient.delete<any>(
    `${this.basePath}/api/GroupRoles/${roleGroupId}`);
  }


public apiPlatformodulesGet(): Observable<PlatformModuleDTO[]> {
  return this.httpClient.get<PlatformModuleDTO[]>(`${this.basePath}/api/PlatformModule`);
}

/// Get by id  of TenantModule 
public apiTenantModuleByIdGet(TenantId?: string): Observable<TenantModuleDTO[]> {
  return this.httpClient.get<TenantModuleDTO[]>(`${this.basePath}/api/TenantModules/${encodeURIComponent(String(TenantId))}`);
}

  //Get list of all user tenant
  public getUserTenant(): Observable<any> {
    return this.httpClient.get(`${this.basePath}/api/Users/tenants`);
  }

  //Update user tenant based on selected tenant id
  public updateTenant(tenantId: string): Observable<any> {
    return this.httpClient.put(
      `${this.basePath}/api/Users/ChangeTenant/${tenantId}`,{});
  }

   // POST Tenant
  public CreateTenant(tenant: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.basePath}/api/Tenants`,
      tenant
    );
  }

  // Salesman-facing tenant provisioning (wizard). Creates tenant + modules + menus + admin login.
  public ProvisionTenant(body: CreateTenantRequest): Observable<CreateTenantResult> {
    return this.httpClient.post<CreateTenantResult>(
      `${this.basePath}/api/Tenants/provision`,
      body
    );
  }

  public DuplicateTenant(tenantName: string): Observable<string> {
    const params = new HttpParams().set('TenantName', tenantName);
    return this.httpClient.post(
      `${this.basePath}/api/Tenants/duplicate`,
      null,
      { params, responseType: 'text' }
    );
  }

  // Resets the dev login's password, or creates the login when the dev tenant has none.
  // The password is only ever returned here - it is not stored server-side.
  public ResetDuplicateTenantPassword(tenantName: string): Observable<DevTenantCredentialsResult> {
    const params = new HttpParams().set('TenantName', tenantName);
    return this.httpClient.post<DevTenantCredentialsResult>(
      `${this.basePath}/api/Tenants/duplicate/password`,
      null,
      { params }
    );
  }

  public DeleteDuplicateTenant(tenantName: string, confirmationName: string): Observable<string> {
    const params = new HttpParams()
      .set('TenantName', tenantName)
      .set('confirmationName', confirmationName);
    return this.httpClient.delete(
      `${this.basePath}/api/Tenants/duplicate`,
      { params, responseType: 'text' }
    );
  }

}